var map = {
	"./Dsdl_logo.jfif": 128,
	"./Garvit_singhal.jpeg": 129,
	"./Kiet_logo.png": 130,
	"./address_image.svg": 131,
	"./animated_logo.svg": 132,
	"./blogs_image.svg": 133,
	"./cloud_infrastructure.svg": 134,
	"./contactMail.png": 135,
	"./coursera_logo.png": 136,
	"./data_science.svg": 137,
	"./deeplearning_ai_logo.png": 138,
	"./developerActivity.svg": 139,
	"./devupkiet_logo.jfif": 140,
	"./dsc_logo.png": 141,
	"./dsckiet_logo.jfif": 142,
	"./education.svg": 143,
	"./experience.svg": 144,
	"./feelingProud.svg": 145,
	"./fullstack.svg": 146,
	"./gcp_logo.png": 147,
	"./github_logo.png": 148,
	"./googleAssistant.jpg": 149,
	"./googleAssistant.svg": 150,
	"./google_logo.png": 151,
	"./ibm_logo.png": 152,
	"./intel_logo.jpg": 153,
	"./jsFramework.svg": 154,
	"./k3.jfif": 155,
	"./manOnTable.svg": 156,
	"./microsoft_logo.png": 157,
	"./mozilla_logo.png": 158,
	"./none.jpg": 159,
	"./programmer.svg": 160,
	"./projects_image.svg": 161,
	"./stanford_logo.png": 162,
	"./susalabs_logo.png": 163,
	"./talksCardBack.svg": 164,
	"./talksCardBackAlt.svg": 165,
	"./ui_ux_design.svg": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;